// @ts-nocheck
import { get, find, findIndex } from 'lodash'
import Select from 'react-select'
import { CheckOutlined } from '@ant-design/icons'
import { FormFieldLayout } from '../../generic'
import { colors } from '@lmc/common/constants'
import AnimateHeight from 'react-animate-height'
import RiskValue from 'components/carePlans/RiskValue'
import { SearchSelect } from '../../generic'

export default function SelectField({
  defaultOptions,
  errors,
  formatOptionLabel,
  formFieldStyle,
  formKey,
  isSearch,
  onChange,
  style,
  options,
  loadOptions,
  placeholder,
  readOnly,
  values,
  disabled,
  ...props
}) {
  let optionKey
  if (options && options[0]) {
    optionKey = options[0].id ? 'id' : 'value'
  }

  const currentValue = get(values, formKey)
  const error = get(errors, formKey)
  const flatOptions = flattenGroupedOptions(options)
  const selectedOption =
    flatOptions && flatOptions[0] && flatOptions[0].risk
      ? flatOptions[currentValue]
      : find(flatOptions, { [optionKey]: currentValue })

  if (readOnly && selectedOption) {
    const className = selectedOption.risk
      ? 'lmc-risk-option-field-read-only'
      : 'lmc-option-field-read-only'
    return (
      <div
        className={className}
        style={{ borderColor: colors.grey, padding: 7 }}
      >
        <Option
          label={selectedOption.label}
          value={selectedOption.value}
          risk={selectedOption.risk}
        />
      </div>
    )
  }

  const SelectComponent = isSearch ? SearchSelect : Select

  return (
    <FormFieldLayout hasErrors={!!error} style={formFieldStyle} {...props}>
      <div data-testid={props['data-testid']}>
        <SelectComponent
          classNamePrefix={error ? 'lmc-select-error' : 'lmc-select'}
          defaultOptions={defaultOptions}
          formatOptionLabel={formatOptionLabel || Option}
          getOptionLabel={(option) => option.name || option.label}
          getOptionValue={(option) => option.id || option.value}
          isClearable={false}
          options={options}
          loadOptions={loadOptions}
          onChange={(option) =>
            onChange({
              key: formKey,
              value: getChangeValue(flatOptions, option, optionKey),
            })
          }
          placeholder={placeholder}
          style={style}
          value={selectedOption}
          isDisabled={disabled}
        />
      </div>
      <AnimateHeight animateOpacity duration={200} height={error ? 'auto' : 0}>
        <div style={styles.error}>{error}</div>
      </AnimateHeight>
    </FormFieldLayout>
  )
}

const Option = ({ icon, iconLabel, iconColor, label, name, risk, value }) => {
  const iconComponents = {
    check: CheckOutlined,
  }
  const IconComponent = icon && iconComponents[icon]

  return (
    <div style={styles.optionContainer}>
      {risk && <RiskValue risk={risk} value={value} />}
      {iconLabel && (
        <span style={{ ...styles.optionIconLabel, color: iconColor }}>
          {iconLabel}
        </span>
      )}
      {IconComponent && (
        <IconComponent style={{ ...styles.optionIcon, color: iconColor }} />
      )}
      <span>{name || label}</span>
    </div>
  )
}

const getChangeValue = (allOptions, option, optionKey) =>
  option.risk ? findIndex(allOptions, option) : option[optionKey]

const flattenGroupedOptions = (options) => {
  if (options[0] && options[0].options) {
    return options
      .map((option) => option.options)
      .reduce((acc, val) => acc.concat(val), [])
  }
  return options
}

const styles = {
  error: {
    color: colors.red,
    fontSize: 11,
    paddingTop: 5,
  },
  optionContainer: {
    alignItems: 'center',
    display: 'flex',
  },
  optionIconLabel: {
    marginTop: 2,
    width: 32,
    fontWeight: 700,
    fontSize: 12,
  },
  optionIcon: {
    marginTop: 2,
    width: 34,
    fontSize: 16,
    textAlign: 'left',
  },
  readOnly: {
    background: 'white',
    border: '1px solid',
    borderColor: colors.darkgrey,
    borderRadius: 4,
    display: 'inline-block',
    minWidth: 150,
    padding: 8,
  },
}
